// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","443":"about","487":"qrcode","720":"faq","780":"payresult","974":"qrcodeprcing"}[chunkId] + "." + {"177":"9bcf1bd8","443":"b2a988ad","487":"5da995c9","720":"2999fe47","780":"70d2fd8c","974":"48eb7ec2"}[chunkId] + ".css";
};